import AppConstants from '../constants/AppConstants';

export const initialState = {
    loading: false,
    loaded: false,
    store: {
        dataTable: {
            version: 3
        },
        report: {},
        reportByCountry: {},
        reportByDay: {},
        reportByReactivation: {},
        reportByCreative: {},
        reportByReferer: {},
        reportByUTM: {},
        reportByReferral: {}
    }
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case AppConstants.SERVER_STORAGE_START_LOADING:
            return {
                ...state,
                loading: true,
                loaded: false
            };

        case AppConstants.SERVER_STORAGE_SUCCESS:
            let store = {
                ...state.store,
                ...action.items
            };

            return {
                ...state,
                loading: false,
                loaded: true,
                store: dataFormatting(store)
            };

        case AppConstants.SERVER_STORAGE_FAIL:
            return {
                ...state,
                loading: false,
                loaded: true
            };

        default:
            return state;
    }
};

const dataFormatting = (store) => {
    let newStore = {};

    for (let key in initialState.store) {
        newStore[key] = store[key];
    };

    return newStore;
};
